import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Number$isNaN from 'babel-runtime/core-js/number/is-nan';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import Uploader from '@/components/Uploader/index.vue';
import { reduceFileAccept } from '@/common/file';
import { fetchAdvertiserList, fetchAdvertiserInfo, getAdvertiserPartnerInfo } from '@/api/advertiser/manage.ts';
import { createInvoice } from '@/api/finance/invoice';
import { COMPANY_OPTIONS } from '../invoice-options';

var ATTACHMENT_ACCEPT_TYPES = ['pdf', 'jpg', 'jpeg', 'png', 'xls', 'xlsx', 'xlsm', 'eml'];

var defaultForm = function defaultForm() {
  return {
    adv_id: null,
    customer_id: null,
    estimate_company_code: '',
    estimate_company_name: '',
    traffic_type: 'MWS_MONTHLY_SPEND',
    currency: 'USD',
    tax_rate: 0,
    recharge_amount: null,
    amount: null,
    receipt_status: 1,
    remark: '',
    attachments: []
  };
};

export default {
  name: 'InvoiceDialog',
  components: {
    Uploader: Uploader
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      formValue: defaultForm(),
      amountInputSource: 'recharge_amount',
      syncingAmountField: false,
      advertiserList: [],
      invoicesList: [],
      invoiceLoading: false,
      attachmentFileList: [],
      advInfo: {
        country_code: ''
      },
      companyOptions: COMPANY_OPTIONS
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },
    isSingaporeGstApplicable: function isSingaporeGstApplicable() {
      var countryCode = (this.advInfo.country_code || '').trim().toUpperCase();
      return countryCode === 'SG' && ['M5005', 'M6003'].includes(this.formValue.estimate_company_code);
    },
    attachmentAccept: function attachmentAccept() {
      return reduceFileAccept(ATTACHMENT_ACCEPT_TYPES);
    },
    rules: function rules() {
      var validateAttachments = function validateAttachments(rule, value, callback) {
        if (Array.isArray(value) && value.length) {
          callback();
          return;
        }
        callback(new Error('请至少添加一个附件'));
      };
      var r = {
        adv_id: [{ required: true, trigger: 'change', message: '请选择广告主' }],
        customer_id: [{ required: true, trigger: 'change', message: '请选择客户' }],
        estimate_company_code: [{ required: true, trigger: 'change', message: '请选择收款主体' }],
        traffic_type: [{ required: true, trigger: 'blur', message: '请输入流量类型' }],
        currency: [{ required: true, trigger: 'change', message: '请选择币种' }],
        recharge_amount: [{ required: true, trigger: 'blur', message: '请输入充值金额' }],
        amount: [{ required: true, trigger: 'blur', message: '请输入开票金额' }],
        attachments: [{
          required: true,
          validator: validateAttachments,
          trigger: 'change'
        }]
      };
      return r;
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;

      if (val) {
        this.formValue = defaultForm();
        this.amountInputSource = 'recharge_amount';
        this.syncingAmountField = false;
        this.invoicesList = [];
        this.attachmentFileList = [];
        this.advInfo.country_code = '';
        this.$nextTick(function () {
          _this.$refs.form && _this.$refs.form.clearValidate();
          _this.$refs.attachmentUploader && _this.$refs.attachmentUploader.clearFiles();
        });
      }
    },
    'formValue.estimate_company_code': function formValueEstimate_company_code() {
      this.syncEstimateCompanyName();
      this.applyTaxRule();
    },
    'advInfo.country_code': function advInfoCountry_code() {
      this.applyTaxRule();
    },
    'formValue.tax_rate': function formValueTax_rate() {
      this.syncAmountFields();
    }
  },
  methods: {
    getAdvertiserList: function getAdvertiserList() {
      var _this2 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchAdvertiserList(params);

              case 3:
                res = _context.sent;

                _this2.advertiserList = _.get(res, 'data.data.list') || [];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    },
    syncEstimateCompanyName: function syncEstimateCompanyName() {
      var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formValue.estimate_company_code;

      var company = COMPANY_OPTIONS.find(function (c) {
        return c.code === code;
      });
      this.formValue.estimate_company_name = company ? company.name : '';
    },
    handleCompanyChange: function handleCompanyChange(code) {
      this.syncEstimateCompanyName(code);
      this.applyTaxRule();
    },
    handleAdvChange: function handleAdvChange() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, info;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 切换广告主时清空客户选择
                _this3.formValue.customer_id = null;
                _this3.invoicesList = [];
                _this3.advInfo.country_code = '';
                _this3.applyTaxRule();

                if (_this3.formValue.adv_id) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                _context2.prev = 6;

                _this3.invoiceLoading = true;
                _context2.next = 10;
                return fetchAdvertiserInfo({ id: _this3.formValue.adv_id });

              case 10:
                res = _context2.sent;
                info = _.get(res, 'data.data.info') || {};

                _this3.invoicesList = info.invoices || [];
                _context2.next = 15;
                return _this3.getAdvertiserCountryCode(_this3.formValue.adv_id);

              case 15:
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](6);

                console.error(_context2.t0);

              case 20:
                _context2.prev = 20;

                _this3.invoiceLoading = false;
                _this3.applyTaxRule();
                return _context2.finish(20);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 17, 20, 24]]);
      }))();
    },
    getAdvertiserCountryCode: function getAdvertiserCountryCode(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res, partnerInfoList, countryCode;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getAdvertiserPartnerInfo({ adv_id: id });

              case 3:
                res = _context3.sent;
                partnerInfoList = _.get(res, 'data.data.list') || [];
                countryCode = partnerInfoList.length ? partnerInfoList[0].country_code : '';

                _this4.advInfo.country_code = (countryCode || '').trim().toUpperCase();
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                _this4.advInfo.country_code = '';
                console.error(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 9]]);
      }))();
    },
    applyTaxRule: function applyTaxRule() {
      var nextTaxRate = this.isSingaporeGstApplicable ? 9 : 0;
      if (this.formValue.tax_rate !== nextTaxRate) {
        this.formValue.tax_rate = nextTaxRate;
        return;
      }
      this.syncAmountFields();
    },
    handleRechargeAmountChange: function handleRechargeAmountChange(value) {
      if (this.syncingAmountField) return;
      this.amountInputSource = 'recharge_amount';
      this.syncAmountFromRechargeAmount(value);
    },
    handleInvoiceAmountChange: function handleInvoiceAmountChange(value) {
      if (this.syncingAmountField) return;
      this.amountInputSource = 'amount';
      this.syncRechargeAmountFromInvoiceAmount(value);
    },
    normalizeAmountValue: function normalizeAmountValue(value) {
      if (_.isNil(value) || value === '') return null;
      var amount = Number(value);
      return _Number$isNaN(amount) ? null : amount;
    },
    syncAmountFields: function syncAmountFields() {
      if (this.amountInputSource === 'amount') {
        this.syncRechargeAmountFromInvoiceAmount(this.formValue.amount);
        return;
      }
      this.syncAmountFromRechargeAmount(this.formValue.recharge_amount);
    },
    syncAmountFromRechargeAmount: function syncAmountFromRechargeAmount() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formValue.recharge_amount;

      var rechargeAmount = this.normalizeAmountValue(value);
      var taxRate = this.normalizeAmountValue(this.formValue.tax_rate) || 0;
      var taxRateFactor = taxRate / 100;

      if (_.isNil(rechargeAmount)) {
        this.syncingAmountField = true;
        this.formValue.amount = null;
        this.syncingAmountField = false;
        return;
      }

      this.syncingAmountField = true;
      this.formValue.amount = Number((rechargeAmount * (1 + taxRateFactor)).toFixed(2));
      this.syncingAmountField = false;
    },
    syncRechargeAmountFromInvoiceAmount: function syncRechargeAmountFromInvoiceAmount() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formValue.amount;

      var amount = this.normalizeAmountValue(value);
      var taxRate = this.normalizeAmountValue(this.formValue.tax_rate) || 0;
      var taxRateFactor = taxRate / 100;
      var taxMultiplier = 1 + taxRateFactor;

      if (_.isNil(amount)) {
        this.syncingAmountField = true;
        this.formValue.recharge_amount = null;
        this.syncingAmountField = false;
        return;
      }

      if (taxMultiplier <= 0) {
        this.syncingAmountField = true;
        this.formValue.recharge_amount = null;
        this.syncingAmountField = false;
        return;
      }

      this.syncingAmountField = true;
      this.formValue.recharge_amount = Number((amount / taxMultiplier).toFixed(2));
      this.syncingAmountField = false;
    },
    formatTaxRateDisplay: function formatTaxRateDisplay(value) {
      var taxRate = Number(value);
      return _Number$isNaN(taxRate) ? 0 : taxRate;
    },
    getAttachmentExtension: function getAttachmentExtension(file) {
      var fileName = _.get(file, 'name', '');
      var extension = fileName.includes('.') ? fileName.split('.').pop() : '';
      return (extension || '').toLowerCase();
    },
    beforeAttachmentUpload: function beforeAttachmentUpload(file) {
      var extension = this.getAttachmentExtension(file);
      if (!ATTACHMENT_ACCEPT_TYPES.includes(extension)) {
        this.$message.warning('附件仅支持 PDF、JPG、JPEG、PNG、XLS、XLSX、XLSM、EML 格式');
        return false;
      }
      var isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.warning('上传文件大小不能超过 100MB');
        return false;
      }
      return true;
    },
    handleAttachmentChange: function handleAttachmentChange(file, fileList) {
      this.attachmentFileList = fileList;
      this.syncAttachmentsFromFileList(fileList);
      this.validateAttachmentField();
    },
    handleAttachmentUploadSuccess: function handleAttachmentUploadSuccess(response, file, fileList) {
      if (response.code !== 0) {
        this.$message.warning(response.msg || '附件上传失败，请重试');
        this.attachmentFileList = fileList.filter(function (item) {
          return item.uid !== file.uid;
        });
        this.syncAttachmentsFromFileList(this.attachmentFileList);
        this.validateAttachmentField();
        return;
      }
      file.name = response.data.origin_name;
      file.url = response.data.file_path;
      this.attachmentFileList = fileList;
      this.syncAttachmentsFromFileList(fileList);
      this.validateAttachmentField();
    },
    handleAttachmentRemove: function handleAttachmentRemove(file, fileList) {
      this.attachmentFileList = fileList;
      this.syncAttachmentsFromFileList(fileList);
      this.validateAttachmentField();
    },
    handleAttachmentPreview: function handleAttachmentPreview(file) {
      var fileUrl = _.get(file, 'response.data.file_path') || file.url || _.get(file, 'raw.url');
      fileUrl && window.open(fileUrl);
    },
    syncAttachmentsFromFileList: function syncAttachmentsFromFileList() {
      var fileList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.attachmentFileList;

      this.formValue.attachments = fileList.map(function (item) {
        return {
          file_name: _.get(item, 'response.data.origin_name') || item.name || '',
          file_url: _.get(item, 'response.data.file_path') || item.url || ''
        };
      }).filter(function (item) {
        return item.file_name && item.file_url;
      });
    },
    validateAttachmentField: function validateAttachmentField() {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs.form && _this5.$refs.form.validateField('attachments');
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('update:visible', false);
    },
    submit: function submit() {
      var _this6 = this;

      this.$refs.form.validate(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(valid) {
          var attachments, _formValue, recharge_amount, payload, amount, rechargeAmount, taxRate;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (valid) {
                    _context4.next = 2;
                    break;
                  }

                  return _context4.abrupt('return');

                case 2:
                  // 过滤掉空附件
                  attachments = _this6.formValue.attachments.filter(function (a) {
                    return a.file_name || a.file_url;
                  });
                  _formValue = _this6.formValue, recharge_amount = _formValue.recharge_amount, payload = _objectWithoutProperties(_formValue, ['recharge_amount']);
                  amount = Number(_this6.formValue.amount || 0);
                  rechargeAmount = Number(recharge_amount || 0);
                  taxRate = Number(_this6.formValue.tax_rate || 0);
                  _context4.prev = 7;

                  _this6.loading = true;
                  _context4.next = 11;
                  return createInvoice(_extends({}, payload, {
                    tax: Number((rechargeAmount * taxRate / 100).toFixed(2)),
                    actual_amount: amount,
                    amount: amount,
                    attachments: attachments
                  }));

                case 11:
                  _this6.$message.success('提交成功');
                  _this6.closeDialog();
                  _this6.$emit('save-success');
                  _context4.next = 19;
                  break;

                case 16:
                  _context4.prev = 16;
                  _context4.t0 = _context4['catch'](7);

                  console.error(_context4.t0);

                case 19:
                  _context4.prev = 19;

                  _this6.loading = false;
                  return _context4.finish(19);

                case 22:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this6, [[7, 16, 19, 22]]);
        }));

        return function (_x6) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};